/**
 * Shared input error styles.
 * Import and spread into makeStyles definitions.
 *
 * Usage:
 *   import { inputErrorBorder, buttonErrorBorder } from '@/styles/inputStyles.ts';
 *
 *   const useStyles = makeStyles(() => ({
 *       textFieldsError: {
 *           height: '3.75em',
 *           ...inputErrorBorder,
 *       },
 *   }));
 */
import { alpha } from '@material-ui/core/styles';

const ERROR_COLOR = '#da3030';

/**
 * Apply on TextField root (wrapper) to turn the inner MuiFilledInput border red.
 * Use when the error class is set on the TextField `classes.root`.
 */
export const inputErrorBorder = {
    '& .MuiFilledInput-root': {
        border: `1px solid ${ERROR_COLOR}`,
    },
};

/**
 * Apply directly on a Button or element that already has its own border.
 * Use for dropdowns (DefaultDropDown, TelephoneDropDown button, etc.).
 */
export const buttonErrorBorder = {
    borderColor: ERROR_COLOR,
};

export const fieldArrowColor = (theme: any) => alpha(theme.palette.common.darkGrey, 0.46);

export const filledFieldFocused = (theme: any) => ({
    backgroundColor: 'white',
    border: `2px solid ${theme.palette.common.yellow} !important`,
});

export const dropdownFieldBase = (theme: any) => ({
    width: '100%',
    backgroundColor: 'white',
    border: `1px solid ${theme.palette.common.brown}`,
    paddingTop: 14,
    paddingBottom: 14,
    height: '3.75rem',
    justifyContent: 'space-between',
    borderRadius: theme.radius.default,
    '&:hover': {
        backgroundColor: theme.palette.common.cream_disable,
    },
    '&:focus, &:focus-visible, &.Mui-focusVisible': {
        backgroundColor: 'white',
        border: `2px solid ${theme.palette.common.yellow}`,
    },
});

export const rightFilledFieldRoot = (theme: any) => ({
    overflow: 'hidden',
    backgroundColor: 'white',
    border: `1px solid ${theme.palette.common.brown}`,
    paddingRight: 10,
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    borderTopRightRadius: theme.radius.default,
    borderBottomRightRadius: theme.radius.default,
    fontSize: '1rem',
    '&:hover': {
        backgroundColor: theme.palette.common.cream_disable,
    },
});
